import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import Swal from 'sweetalert2';
import { IoClose } from 'react-icons/io5';
import axios from 'axios';
import ClipLoader from 'react-spinners/ClipLoader';
import { AxiosInstance } from '../../../../common/Loader/axios.config';


const UploadContentModal = ({ isOpen, onClose, product }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        package_name: '',
        category: '',
        price: '',
        product: '',
        video: null,
        // thumbnail: null,
    });

    // const AxiosInstance = axios.create({
    //     baseURL: 'https://dev.staticcomputersinc.com/kanemaonline',
    // });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData({ ...formData, [name]: files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        Object.keys(formData).forEach(key => {
            if (formData[key]) {
                formDataToSend.append(key, formData[key]);
            }
        });
        formDataToSend.append('product', product);

        console.log("Form Data:");
        for (let [key, value] of formDataToSend.entries()) {
            console.log(`${key}:`, value);
        }

        setLoading(true);

        AxiosInstance.post('/video-content', formDataToSend)
            .then(response => {
                console.log("Upload Response", response);
                if (response.data.status === "successful") {
                    const contentId = response.data.message.title;
                    Swal.fire({
                        icon: 'success',
                        title: 'Content Created successfully!',
                        text: `Content : ${contentId}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    onClose();
                    // fetchProducts();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to create content',
                        text: `${response.data.message}`,
                        showConfirmButton: false,
                        timer: 2000,
                    });
                    setLoading(false);
                }
            })
            .catch(error => {
                Swal.fire({
                    icon: 'error',
                    title: 'Upload Failed',
                    title: 'Upload Failed',
                    text: 'An error occurred while uploading.',
                });
                setLoading(false);
            });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2 relative">
                <button onClick={onClose} className="absolute top-4 right-4 text-white text-2xl">
                    <IoClose />
                </button>
                <h2 className="text-lg font-semibold mb-4 text-white">Upload Content</h2>
                <form onSubmit={handleSubmit} className="w-full flex flex-col gap-3">
                    <div>
                        <label className="block mb-2 text-white">Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="category" className="block text-sm font-medium text-gray-700">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="w-full rounded border border-brand-stroke-color bg-transparent p-2 text-white"
                            required
                        >
                            <option value="">Select Category...</option>
                            <option value="tv">TV</option>
                            <option value="vod">Video</option>
                            <option value="event">Event</option>
                            <option value="shorts">Shorts</option>
                            <option value="series">Series</option>
                        </select>
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Package Name</label>
                        <input
                            type="text"
                            name="package_name"
                            value={formData.package_name}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Price</label>
                        <input
                            type="text"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Video</label>
                        <input
                            type="file"
                            accept="video/*"
                            name="video"
                            onChange={handleFileChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div>
                    {/* <div>
                        <label className="block mb-2 text-white">Thumbnail</label>
                        <input
                            type="file"
                            accept="image/*"
                            name="thumbnail"
                            onChange={handleFileChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white"
                            required
                        />
                    </div> */}
                    <div className="col-span-2">
                        <button type="submit" className="bg-primary text-white py-2 px-4 rounded">
                            {loading ? <ClipLoader size={20} color="#FFFFFF" /> : 'Upload'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UploadContentModal;
